export default "__VITE_ASSET__CIwlRk3o__"